import { render, staticRenderFns } from "./AssignmentCourier.vue?vue&type=template&id=eb18dde2&scoped=true&"
import script from "./AssignmentCourier.vue?vue&type=script&lang=js&"
export * from "./AssignmentCourier.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentCourier.vue?vue&type=style&index=0&id=eb18dde2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb18dde2",
  null
  
)

export default component.exports